import React from "react";

/**
 * The lines behind a chip that stands in for a list.
 *
 * One element per line rather than a string with newlines: `Tooltip` renders
 * `details` as a node, and a run of names separated by commas is not a list
 * anyone reads at a glance — which is the whole reason the audience chip counts
 * instead of naming.
 *
 * Deliberately not a `<ul>`. `Tooltip`'s details are supplementary and outside
 * the accessible name by design, so list semantics would announce structure for
 * something a screen reader is not being given anyway.
 */
export const ChipDetail: React.FC<{ lines: string[] }> = ({ lines }) => (
	<span className="em-chip-tip">
		{lines.map((line) => (
			<span key={line} className="em-chip-tip__line">
				{line}
			</span>
		))}
	</span>
);
